<template>
  <div :class="['navbarwrapper', this.homeNavbar ? 'transparent absolute' : '']">
    <div class="navbar">
      <router-link to="/" class="navitem">
        <div class="navitemicon">
          <font-awesome-icon icon="tree" class="icon" />
        </div>

        <span>Koti</span>
      </router-link>
      <router-link to="/aikataulu" class="navitem">
        <!-- <font-awesome-icon icon="calendar" class="icon"/> -->
        <span>Aikataulu</span>
      </router-link>
      <router-link to="/kalenteri" class="navitem">
        <!--<font-awesome-icon icon="gift" class="icon"/> -->
        <span>Joulukalenteri</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      homeNavbar: this.$route.path === "/"
    };
  },
  watch: {
    $route() {
      if (this.$route.path === "/") {
        this.homeNavbar = true;
      } else {
        this.homeNavbar = false;
      }
    }
  }
};
</script>

<style scoped>
.navbarwrapper {
  display: flex;
  justify-content: center;
  position: relative;
  border-color: #c74444;
}

.navbar {
  z-index: 3;
  padding: 1.3em 3em;
  padding-top: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  flex-shrink: 0;
  max-width: 750px;
  position: relative;
  flex-basis: auto;
}

.navbar::after {
  content: "";
  display: block;
  height: 2px;
  opacity: 0.08;
  position: absolute;
  width: 100%;
  bottom: 0;
  background-image: linear-gradient(
    -90deg,
    rgba(14, 30, 37, 0) 0,
    #0e1e25 5%,
    #0e1e25 90%,
    rgba(14, 30, 37, 0) 100%
  );
}

.navitem {
  text-decoration: none;
  color: black;
  font-weight: 400;
  font-size: 1.25em;
  padding: 0 0.5em;
  opacity: 0.85;
  transition: all 0.1s ease;
  display: flex;
}

.navitemicon {
  font-size: 0.85em;
  width: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.1em;
}

.navitem:hover,
.navitem:active {
  opacity: 1;
}

.icon {
  margin: 0 0.3em;
}

.absolute {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.transparent .navbar::after {
  background-image: linear-gradient(
    -90deg,
    rgba(255, 255, 255, 0) 0,
    #fff 5%,
    #fff 90%,
    rgba(255, 255, 255, 0) 100%
  );
}

.transparent .navitem {
  color: white;
}

@media screen and (max-width: 550px) {
  .navbar {
    padding: 1em 0;
    font-size: 0.9em;
  }
}
</style>
